import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { User } from '../_models/index';
// import { UserService } from '../_services/index';

@Injectable()
export class ManagerGuard implements CanActivate {

    constructor(private router: Router) { }

    currentUserVAR!: User;
    users: User[] = [];


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (sessionStorage.getItem('currentUser') as string as string) {
            // logged in so return true
                // check the user level
                this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser') as string);
                // console.log('Access Level: ', this.currentUser.access_level);
                // tslint:disable-next-line:prefer-const
                let current_access_level = this.currentUserVAR.access_level;
            // see if Manager
            if (current_access_level === '3' ) {
                
            return true;
            }else {
            return false; // user not an Manager
             }
        }

        // not logged in so redirect to login page with the return url
       // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        this.router.navigate(['/logout'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}
